import WRAP from "WRAP-JS";
import {
  _orderBy,
  formatBaseTime,
  formatValidTime,
  translation
} from "../../../utils/FPEUtils";
import {
  configMsmGroundIcingProbController,
  configMsmGroundLayerIcingProb,
  configMsmGroundLayerIsotach,
  configMsmGroundLayerIsotachMesh,
  configMsmGroundLayerIsotherm,
  configMsmGroundLayerIsothermGrid,
  configMsmGroundLayerStreamLine,
  configMsmGroundLayerWindArrow,
  configMsmGroundSpeedDirectionController,
  configMsmGroundUpConversionController,
  configMsmGroundDh,
  configMSmGroundLayerIsotachGradation,
  configMsmGroundLayerIsothermGradation,
  configMsmGroundPrecipitation1hController,
  configMsmGroundLayerPrecipitation1hMesh,
  configMsmGroundLayerPrecipitation1hContour,
  configMsmGroundLayerPrecipitation1hGrid
} from "./config/ConfigMsmGround";
import { WX_ID_MSM } from "../../../store/WeatherContentsState";
import { nearValidTime } from "../helper/MapUtil";
import MissingDataObserver from "../helper/MissingDataObserver";
import { COMMUNICATE_ERROR_MESSAGE_JMA_SRF_MSM, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD } from "../../../constants/ErrorMessage";

class MsmGround {
  static NAME = `${WX_ID_MSM}_GROUND`;
  static WIND_ARROW_NAME = `${MsmGround.NAME}_WIND_ARROW`;
  static WIND_STREAM_NAME = `${MsmGround.NAME}_WIND_STREAM`;
  static ISOTACH_CONTOUR_NAME = `${MsmGround.NAME}_ISOTACH_CONTOUR`;
  static ISOTACH_MESH_NAME = `${MsmGround.NAME}_ISOTACH_MESH`;
  static ISOTACH_GRADATION_NAME = `${MsmGround.NAME}_ISOTACH_GRADATION`;
  static ISOTHERM_CONTOUR_NAME = `${MsmGround.NAME}_ISOTHERM_CONTOUR`;
  static ISOTHERM_GRADATION_NAME = `${MsmGround.NAME}_ISOTHERM_GRADATION`;
  static ISOTHERM_GRID_NAME = `${MsmGround.NAME}_ISOTHERM_VALUE`;
  static ICING_PROB_NAME = `${MsmGround.NAME}_ICING_PROB_NAME`;
  static PRECIPITATION_1H_MESH_NAME = `${MsmGround.NAME}_PRECIPITATION_1H_MESH`;
  static PRECIPITATION_1H_CONTOUR_NAME = `${MsmGround.NAME}_PRECIPITATION_1H_CONTOUR`;
  static PRECIPITATION_1H_GRID_NAME = `${MsmGround.NAME}_PRECIPITATION_1H_GRID`;
  static CONTENTS_VISIBLE_STATE_DEFAULT = {
    [MsmGround.WIND_ARROW_NAME]: false,
    [MsmGround.WIND_STREAM_NAME]: true,
    [MsmGround.ISOTACH_CONTOUR_NAME]: true,
    [MsmGround.ISOTACH_MESH_NAME]: true,
    [MsmGround.ISOTACH_GRADATION_NAME]: false,
    [MsmGround.ISOTHERM_CONTOUR_NAME]: true,
    [MsmGround.ISOTHERM_GRADATION_NAME]: false,
    [MsmGround.ISOTHERM_GRID_NAME]: false,
    [MsmGround.ICING_PROB_NAME]: true,
    [MsmGround.PRECIPITATION_1H_MESH_NAME]: true,
    [MsmGround.PRECIPITATION_1H_CONTOUR_NAME]: true,
    [MsmGround.PRECIPITATION_1H_GRID_NAME]: false
  };

  contentsVisibleState = {...MsmGround.CONTENTS_VISIBLE_STATE_DEFAULT};
  dh;
  dhSpeedDirectionController;
  dhUpConversionController;
  dhIcingProbController;
  dhPrecipitationController;
  dhAutoUpdate = true;
  ready = false;
  layerWindArrow;
  layerStream;
  layerIsotach;
  layerIsotachMesh;
  layerIsotachGradation;
  layerIsotherm;
  layerIsothermGradation;
  layerIsothermGrid;
  layerIcingProb;
  layerPrecipitation1hMesh;
  layerPrecipitation1hContour;
  layerPrecipitation1hGrid;
  etd;
  elapsed = 0;
  baseTime = '---';
  validTime = '---';
  altitude = 0;
  level;
  dispatcher;
  visible;
  isDark;
  // MSMタイムコントローラー
  timeController;
  // 自動更新フラグ
  autoRefresh = true;
  errorMessageInfo = {};

  constructor(isDark, timeController) {
    this.isDark = isDark;
    this.timeController = timeController;
    this.layerWindArrow = new WRAP.Geo.Layer(MsmGround.WIND_ARROW_NAME);
    this.layerStream = new WRAP.Geo.Layer(MsmGround.WIND_STREAM_NAME);
    this.layerIsotach = new WRAP.Geo.Layer(MsmGround.ISOTACH_CONTOUR_NAME);
    this.layerIsotachMesh = new WRAP.Geo.Layer(MsmGround.ISOTACH_MESH_NAME);
    this.layerIsotachGradation = new WRAP.Geo.Layer(MsmGround.ISOTACH_GRADATION_NAME);
    this.layerIsotherm = new WRAP.Geo.Layer(MsmGround.ISOTHERM_CONTOUR_NAME);
    this.layerIsothermGradation = new WRAP.Geo.Layer(MsmGround.ISOTHERM_GRADATION_NAME);
    this.layerIsothermGrid = new WRAP.Geo.Layer(MsmGround.ISOTHERM_GRID_NAME);
    this.layerIcingProb = new WRAP.Geo.Layer(MsmGround.ICING_PROB_NAME);
    this.layerPrecipitation1hMesh = new WRAP.Geo.Layer(MsmGround.PRECIPITATION_1H_MESH_NAME)
    this.layerPrecipitation1hContour = new WRAP.Geo.Layer(MsmGround.PRECIPITATION_1H_CONTOUR_NAME)
    this.layerPrecipitation1hGrid = new WRAP.Geo.Layer(MsmGround.PRECIPITATION_1H_GRID_NAME)

    this.layerWindArrow.setVisible(false);
    this.layerStream.setVisible(false);
    this.layerIsotach.setVisible(false);
    this.layerIsotachMesh.setVisible(false);
    this.layerIsotachGradation.setVisible(false);
    this.layerIsotherm.setVisible(false);
    this.layerIsothermGradation.setVisible(false);
    this.layerIsothermGrid.setVisible(false);
    this.layerIcingProb.setVisible(false);
    this.layerPrecipitation1hMesh.setVisible(false);
    this.layerPrecipitation1hContour.setVisible(false);
    this.layerPrecipitation1hGrid.setVisible(false);

    this.layerWindArrow.disableInteraction(true);
    this.layerStream.disableInteraction(true);
    this.layerIsotach.disableInteraction(true);
    this.layerIsotachMesh.disableInteraction(true);
    this.layerIsotachGradation.disableInteraction(true);
    this.layerIsotherm.disableInteraction(true);
    this.layerIsothermGradation.disableInteraction(true);
    this.layerIsothermGrid.disableInteraction(true);
    this.layerIcingProb.disableInteraction(true);
    this.layerPrecipitation1hMesh.disableInteraction(true);
    this.layerPrecipitation1hContour.disableInteraction(true);
    this.layerPrecipitation1hGrid.disableInteraction(true);
  }

  setDispatcher(dispatcher) {
    this.dispatcher = dispatcher;
    this.missingDataObserver = new MissingDataObserver(this.dispatcher, MISSING_THRESHOLD, this);
  }

  async initialize() {
    try {
      await this.initData();
    } finally {
      this.initLayer();
      this.initTimeController();
      this.ready = true;
    }
  }

  initData() {
    return new Promise((resolve, reject) => {
      this.dh = new WRAP.Data(configMsmGroundDh);

      this.missingDataObserver.monitoring(MsmGround.NAME, this.dh, () => ({
        //複数のレイヤーがあるので、ここではvisibleを返すLayerの代わりを設定
        visible: () => this.visible
      }), {
        makeTimelist: (_, ref) => {
          if (!ref) return [];
          return ref.timelist.map(t => t.basetime);
        }
      });

      this.dh.updated('timelist', (ref) => {
        resolve();
        this._selectBaseValidTime(ref);

        if (this.updateTimeFunc) {
          this.updateTimeFunc();
        }
      });
      this.dh.updated('basetime', () => {
        if (this.errorMessageInfo.basetime) {
          this.dispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo.basetime});
          this.errorMessageInfo.basetime = null;
        }
      }, () => {
        this.errorMessageInfo.basetime = this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_JMA_SRF_MSM,
          replacement: {data: 'basetime'},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }});
        reject();
      });
      this.dh.updated('validtime', () => {
        if (this.errorMessageInfo.validtime) {
          this.dispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo.validtime});
          this.errorMessageInfo.validtime = null;
        }
      }, () => {
        this.errorMessageInfo.validtime = this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_JMA_SRF_MSM,
          replacement: {data: 'validtime'},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }});
        reject();
      });
      this.dh.updated('region', null, () => {
        this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_JMA_SRF_MSM,
          replacement: {data: 'region'},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
        reject();
      });
      this.dh.updated('level', null, () => {
        this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_JMA_SRF_MSM,
          replacement: {data: 'level'},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
        reject();
      });
      this.dh.updated('element', null, () => {
        this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_JMA_SRF_MSM,
          replacement: {data: 'element'},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
        reject();
      });
      this.dh.updated('updatetime', null, () => {
        this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_JMA_SRF_MSM,
          replacement: {data: 'updatetime'},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
        reject();
      });

      this.dhSpeedDirectionController = new WRAP.Data(configMsmGroundSpeedDirectionController);
      this.dhUpConversionController = new WRAP.Data(configMsmGroundUpConversionController);
      this.dhIcingProbController = new  WRAP.Data(configMsmGroundIcingProbController);
      this.dhPrecipitationController = new WRAP.Data(configMsmGroundPrecipitation1hController);

      this.dh.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });
      this.dhSpeedDirectionController.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });
      this.dhUpConversionController.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });
      this.dhIcingProbController.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });
      this.dhPrecipitationController.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });
    });
  }

  initLayer() {
    this.layerWindArrow.configure(this.dh, configMsmGroundLayerWindArrow);
    this.layerStream.configure(this.dh, configMsmGroundLayerStreamLine);
    this.layerIsotach.configure(this.dhSpeedDirectionController, configMsmGroundLayerIsotach);
    this.layerIsotachMesh.configure(this.dhSpeedDirectionController, configMsmGroundLayerIsotachMesh);
    this.layerIsotachGradation.configure(this.dhSpeedDirectionController, configMSmGroundLayerIsotachGradation);
    this.layerIsotherm.configure(this.dhUpConversionController, configMsmGroundLayerIsotherm);
    this.layerIsothermGradation.configure(this.dhUpConversionController, configMsmGroundLayerIsothermGradation);
    this.layerIsothermGrid.configure(this.dh, configMsmGroundLayerIsothermGrid);
    this.layerIcingProb.configure(this.dhIcingProbController, configMsmGroundLayerIcingProb);
    this.layerPrecipitation1hMesh.configure(this.dhPrecipitationController, configMsmGroundLayerPrecipitation1hMesh);
    this.layerPrecipitation1hContour.configure(this.dhPrecipitationController, configMsmGroundLayerPrecipitation1hContour);
    this.layerPrecipitation1hGrid.configure(this.dhPrecipitationController, configMsmGroundLayerPrecipitation1hGrid);

    this.applyMapColor(null, this.isDark);

    this.layerWindArrow.setVisible(false);
    this.layerStream.setVisible(false);
    this.layerIsotach.setVisible(false);
    this.layerIsotachMesh.setVisible(false);
    this.layerIsotachGradation.setVisible(false);
    this.layerIsotherm.setVisible(false);
    this.layerIsothermGradation.setVisible(false);
    this.layerIsothermGrid.setVisible(false);
    this.layerIcingProb.setVisible(false);
    this.layerPrecipitation1hMesh.setVisible(false);
    this.layerPrecipitation1hContour.setVisible(false);
    this.layerPrecipitation1hGrid.setVisible(false);
  }

  initTimeController() {
    this._allLayers().forEach(layer => {
      this.timeController.addLayer(layer);
    });
    if (this.visible) {
      this.timeController.setDisplayTime(this.validTime);
    }
  }

  async drawLayer(visible) {
    this.visible = visible;
    if (!this.ready && !this.dh) {
      await this.initialize();
    }
    this.setVisible(this.visible);
  }

  getLayer() {
    return this._allLayers();
  }

  setVisible(visible, contents) {

    if (contents) {
      this.contentsVisibleState[contents] = visible;
      if (contents === MsmGround.ISOTACH_CONTOUR_NAME) {
        this.contentsVisibleState[MsmGround.ISOTACH_MESH_NAME] = visible;
      }
    }

    if (!this.ready) return;

    let target;
    switch (contents) {
      case MsmGround.WIND_ARROW_NAME:
        target = [this.layerWindArrow];
        break;
      case MsmGround.WIND_STREAM_NAME:
        target = [this.layerStream];
        break;
      case MsmGround.ISOTACH_CONTOUR_NAME:
        target = [this.layerIsotach, this.layerIsotachMesh];
        break;
      case MsmGround.ISOTACH_GRADATION_NAME:
        target = [this.layerIsotachGradation];
        break;
      case MsmGround.ISOTHERM_CONTOUR_NAME:
        target = [this.layerIsotherm];
        break;
      case MsmGround.ISOTHERM_GRADATION_NAME:
        target = [this.layerIsothermGradation];
        break;
      case MsmGround.ISOTHERM_GRID_NAME:
        target = [this.layerIsothermGrid];
        break;
      case MsmGround.ICING_PROB_NAME:
        target = [this.layerIcingProb];
        break;
      case MsmGround.PRECIPITATION_1H_MESH_NAME:
        target = [this.layerPrecipitation1hMesh];
        break;
      case MsmGround.PRECIPITATION_1H_CONTOUR_NAME:
        target = [this.layerPrecipitation1hContour];
        break;
      case MsmGround.PRECIPITATION_1H_GRID_NAME:
        target = [this.layerPrecipitation1hGrid];
        break;
      default:
        target = this._allLayers();
    }

    if (visible && this.visible) {
      target.forEach(layer => {
        const layerName = layer.name();
        if (this.contentsVisibleState[layerName]) {
          layer.show();
        }
      });
    } else {
      target.forEach(layer => {layer.hide()})
    }

    if (contents === undefined) {
      const enabled = visible && this.autoRefresh;
      if (this.dhAutoUpdate !== enabled) {
        this.dh.setAutoUpdate('timelist', enabled);
        this.dhSpeedDirectionController.setAutoUpdate('timelist', enabled);
        this.dhUpConversionController.setAutoUpdate('timelist', enabled);
        this.dhIcingProbController.setAutoUpdate('timelist', enabled);
        this.dhPrecipitationController.setAutoUpdate('timelist', enabled);
        this.dhAutoUpdate = enabled;
      }
      this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
    }
  }

  getTimeInformation() {
    return {
      id: MsmGround.NAME,
      label: `MSM ${translation('Ground')}`,
      baseTime: {
        id: MsmGround.NAME,
        time: this.baseTime
      },
      validTime: this.validTime,
      baseTimeFormatter: (time) => formatBaseTime(time.time),
      validTimeFormatter: formatValidTime
    };
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  resetContentsVisibleState() {
    this.contentsVisibleState = {...MsmGround.CONTENTS_VISIBLE_STATE_DEFAULT};
  }

  applyIndividualAltitude(altitude) {
    if (this.altitude !== altitude) {
      this.altitude = altitude;
      const level = '0';
      if (this.level !== level) {
        this._updateDataset();
      }
    }
  }

  applyElapsed(elapsed) {
    this.elapsed = elapsed;

    if (!this.ready) return;

    this._selectBaseValidTime(this.dh.retained.timelist);
  }

  applyPlanETD(etd) {
    this.etd = etd;

    if (!this.ready) return;

    this._selectBaseValidTime(this.dh.retained.timelist);
  }

  setAutoRefresh(autoFlg) {
    if (autoFlg === this.autoRefresh) {
      return;
    }

    this.autoRefresh = autoFlg;

    if (!this.ready) {
      return;
    }
    // コンテンツの自動更新を切り替え
    this.dh.setAutoUpdate('timelist', this.autoRefresh);
    this.dhSpeedDirectionController.setAutoUpdate('timelist', this.autoRefresh);
    this.dhUpConversionController.setAutoUpdate('timelist', this.autoRefresh);
    this.dhIcingProbController.setAutoUpdate('timelist', this.autoRefresh);
    this.dhPrecipitationController.setAutoUpdate('timelist', this.autoRefresh);
    this.dhAutoUpdate = this.autoRefresh;
  }

  setUpdateTimeFunc(func) {
    this.updateTimeFunc = func;
  }

  _selectBaseValidTime(ref) {
    let timeList = ref;
    if (!timeList) return;
    timeList = timeList.timelist;

    let targetTime;
    if (!this.etd) {
      //プラン未選択時
      if (!this.autoRefresh) {
        //タイムコントローラ操作時にレーダーを追加した場合、タイムコントローラの選択時制
        targetTime = this.timeController.getCurrentTime();
      } else {
        targetTime = Date.now();
      }
    } else {
      //プラン選択時
      targetTime = this.etd.getTime() + this.elapsed * 1000;
    }

    //最新のbasetimeを取得
    const latestBasetime = _orderBy(timeList, ['basetime'], ['desc'])[0];
    
    const vt = nearValidTime(latestBasetime.validtime, targetTime);

    if ((vt && this.validTime !== vt) || this.baseTime !== latestBasetime.basetime) {
      this.baseTime = latestBasetime.basetime;
      this.validTime = vt;
      this._updateDataset();
    }
  }

  /**
   * タイムコントロールモード時のvalid選択
   */
  _validateTime(data, displayTime, content) {
    if (!data.retained.timelist) {
      return false;
    }
    // 最新のbasetimeを取得
    const latestBasetime = _orderBy(data.retained.timelist.timelist, ['basetime'], ['desc'])[0];

    const vt = nearValidTime(latestBasetime.validtime, displayTime);
    if (vt) {
      this.validTime = content.validtime = vt;
      return true;
    }
    return false;
  }

  _updateDataset() {
    if (this.baseTime !== '---' && this.validTime !== '---') {
      this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
      this.level = '0';

      this.layerWindArrow.set({
        element: ['UWIND', 'VWIND'],
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerStream.set({
        element: ['UWIND', 'VWIND'],
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsotach.set({
        element: "Speed",
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsotachMesh.set({
        element: "Speed",
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsotachGradation.set({
        element: "Speed",
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsotherm.set({
        element: 'AIRTMP',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsothermGradation.set({
        element: 'AIRTMP',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsothermGrid.set({
        element: 'AIRTMP',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIcingProb.set({
        element: 'IcingProb',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });
      
      this.layerPrecipitation1hMesh.set({
        element: 'PRCRIN_1HOUR',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerPrecipitation1hContour.set({
        element: 'PRCRIN_1HOUR',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerPrecipitation1hGrid.set({
        element: 'PRCRIN_1HOUR',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });
    }
  }

  _allLayers() {
    return [
      this.layerPrecipitation1hMesh,
      this.layerPrecipitation1hContour,
      this.layerPrecipitation1hGrid,
      this.layerIsothermGradation,
      this.layerIsotherm,
      this.layerIsothermGrid,
      this.layerIsotachGradation,
      this.layerIsotachMesh,
      this.layerIsotach,
      this.layerIcingProb,
      this.layerWindArrow,
      this.layerStream
    ];
  }

  applyMapColor(mapColor, isDark) {
    this.isDark = isDark;
    const style = this.isDark ? "dark" : "default";
    this.layerIsothermGrid.setStyle(style);
    this.layerIcingProb.setStyle(style);
    this.layerPrecipitation1hGrid.setStyle(style);
  }
}

const MISSING_THRESHOLD = {
  [MsmGround.NAME]: 21600
}
export default MsmGround;